var p = Object.defineProperty, i = Object.defineProperties, l = Object.getOwnPropertyDescriptors, f = Object.getOwnPropertySymbols, o = Object.prototype.hasOwnProperty, _ = Object.prototype.propertyIsEnumerable, n = (r, e, t) => e in r ? p(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, v = (r, e) => {
  for (var t in e || (e = {}))
    o.call(e, t) && n(r, t, e[t]);
  if (f)
    for (var t of f(e))
      _.call(e, t) && n(r, t, e[t]);
  return r;
}, O = (r, e) => i(r, l(e)), P = (r, e) => {
  var t = {};
  for (var a in r)
    o.call(r, a) && e.indexOf(a) < 0 && (t[a] = r[a]);
  if (r != null && f)
    for (var a of f(r))
      e.indexOf(a) < 0 && _.call(r, a) && (t[a] = r[a]);
  return t;
};
export {
  P as __objRest,
  O as __spreadProps,
  v as __spreadValues
};
//# sourceMappingURL=3YLGPPWQ.js.map
